import { CASE_SEARCH_PARAMS_SCHEMA } from '@repo/ccc-case-app-lib/src/constants/caseSearchParamsSchema.ts'
import { CaseDetailPageV2 } from '@repo/ccc-case-app-lib/src/pages/CaseDetailPageV2.tsx'
import { Loader } from '@repo/internal-tools-design-system/src/lib/Loader/Loader.tsx'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useIsCaseDetailV2Enabled } from '../../../lib/useIsCaseDetailV2Enabled.ts'

export const Route = createFileRoute('/_authenticated/cases/$publicCaseId')({
  validateSearch: CASE_SEARCH_PARAMS_SCHEMA,
  component: CaseDetailPageV2Container,
})

function CaseDetailPageV2Container() {
  const { publicCaseId } = Route.useParams()
  const navigate = useNavigate()

  const shouldUseCaseDetailV2 = useIsCaseDetailV2Enabled()

  useEffect(() => {
    if (!shouldUseCaseDetailV2) {
      void navigate({
        to: '/$publicCaseId',
        params: { publicCaseId },
        search: true,
        replace: true,
      })
    }
  }, [navigate, publicCaseId, shouldUseCaseDetailV2])

  if (!shouldUseCaseDetailV2) {
    return (
      <Loader size="sm" withContainer isFullPage>
        Redirecting...
      </Loader>
    )
  }

  return <CaseDetailPageV2 publicCaseId={publicCaseId} />
}
